export default __webpack_public_path__ + "static/media/check-solid-white.08dd829a.png";